/** This whitelist is for query parameters that we want to send off to the api
 */

export const WHITE_LIST = [
  // OAuth parameters
  'response_type',
  'redirect_uri',
  'state',
  'client_id',

  // A path to direct to after login on the Sift app
  'redirectTo',
  // If set to true, will initialize Azure AD permission flow on login, used for MS Teams meeting integration
  'initAzureADLogin',
];
